import { GTM_SELECT_LANGUAGE } from "constant"
import { pushDataLayer } from "./pushDataLayer"

export const gtmPushDataLayerSelectLanguage = (language: string) => {
  pushDataLayer({
    event: GTM_SELECT_LANGUAGE,
    app_language: language,
  })
}
